<template>
    <rkm-overlay>
        <rkm-layout-body title="Lista de encaminhamento">
            <template v-slot:actions>
                <rkm-button
                    @click="$router.push({ name: 'painel-senha-encaminhamento-create' })"
                    color="primary"
                    authorize="store-painel-senha-encaminhamento"
                >
                    Cadastrar encaminhamento
                </rkm-button>
            </template>

            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/painel-senha/encaminhamento/List'

export default {
    components: { List },
}
</script>